module.exports = __webpack_public_path__ + "kunniakierros-logo-se.6e6da71498d93b94ac2a843024a744aa.png";


//////////////////
// WEBPACK FOOTER
// ./app/less/img/kunniakierros-logo-se.png
// module id = 8
// module chunks = 0